import React from "react";
import ContactForm from "./ContactForm"; 

function ContactPage({ setActiveSection }) {
  return (
    <section id="contact" className="min-h-screen flex justify-center items-center">
      <div className="w-full md:w-[800px]">
        <h1 className="text-4xl md:text-6xl font-bold mb-8 md:mb-10">
        </h1>
        <ContactForm />
        <div className="flex flex-col md:flex-row justify-between mt-4">
          <button
            onClick={() => setActiveSection("skills")}
            className="flex items-center w-full md:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 mb-2 md:mb-0 md:mr-2"
          >
            Go back to Skills Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform rotate-180"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
          <button
            onClick={() => setActiveSection("home")}
            className="flex items-center w-full md:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Go to Home Page
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 transform"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
